import template from './whatIsSolidaryCard.html';
import './whatIsSolidaryCard.scss';

let whatIsSolidaryCardComponent = {
  restrict: 'E',
  bindings: {
    cardData: '<',
  },
  template
};

export default whatIsSolidaryCardComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryCard/whatIsSolidaryCard.component.js